'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./Modal.scss');

var cn = _bind2.default.bind(styles);

var Modal = (_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Modal, _Component);

  function Modal() {
    var _ref;

    (0, _classCallCheck3.default)(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call.apply(_ref, [this].concat(args)));

    _this.state = { isOpened: _this.props.show };
    return _this;
  }

  (0, _createClass3.default)(Modal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.show !== this.props.show) {
        this.setState({ isOpened: nextProps.show });
      }
    }
  }, {
    key: 'open',
    value: function open() {
      this.setState({ isOpened: true });
    }
  }, {
    key: 'close',
    value: function close() {
      this.setState({ isOpened: false });
      this.props.onHide();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          footerActions = _props.footerActions,
          closeButton = _props.closeButton,
          autoFocus = _props.autoFocus,
          backdrop = _props.backdrop,
          closeByEsc = _props.closeByEsc,
          bsSize = _props.bsSize,
          dialogClassName = _props.dialogClassName,
          withoutPadding = _props.withoutPadding,
          simpleHeader = _props.simpleHeader,
          className = _props.className,
          warningTitle = _props.warningTitle;


      return _react2.default.createElement(
        _Modal2.default,
        {
          show: this.state.isOpened,
          onHide: this.close,
          className: (0, _bind2.default)(styles.root, className),
          autoFocus: autoFocus,
          backdrop: backdrop,
          keyboard: closeByEsc,
          bsSize: bsSize,
          dialogClassName: dialogClassName
        },
        _react2.default.createElement(
          _Modal2.default.Header,
          { closeButton: closeButton, className: (0, _bind2.default)(styles.header, (0, _defineProperty3.default)({}, styles.simple, simpleHeader)) },
          _react2.default.createElement(
            _Modal2.default.Title,
            { className: (0, _bind2.default)(styles.title, (0, _defineProperty3.default)({}, styles.isWarning, warningTitle)) },
            title
          )
        ),
        _react2.default.createElement(
          _Modal2.default.Body,
          { className: cn('body', { withoutPadding: withoutPadding }) },
          this.props.children
        ),
        !!footerActions && _react2.default.createElement(
          _Modal2.default.Footer,
          { className: styles.footer },
          footerActions
        )
      );
    }
  }]);
  return Modal;
}(_react.Component), _class2.propTypes = {
  autoFocus: _propTypes2.default.bool,
  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
  bsSize: _propTypes2.default.oneOf(['lg', 'large', 'sm', 'small']),
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  className: _propTypes2.default.string,
  closeButton: _propTypes2.default.bool,
  closeByEsc: _propTypes2.default.bool,
  dialogClassName: _propTypes2.default.string,
  footerActions: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  onHide: _propTypes2.default.func,
  show: _propTypes2.default.bool,
  simpleHeader: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  warningTitle: _propTypes2.default.bool,
  withoutPadding: _propTypes2.default.bool
}, _class2.defaultProps = {
  autoFocus: true,
  backdrop: false,
  closeByEsc: true,
  closeButton: true,
  onHide: _noop3.default,
  show: false,
  warningTitle: false
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'close', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'close'), _class.prototype)), _class);
exports.default = Modal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.js
// module id = 212
// module chunks = 1